export default "__VITE_ASSET__CtWXwgKE__"